// extracted by mini-css-extract-plugin
module.exports = {"cell":"TableRowCell-cell-2fbg4"};